document.addEventListener('lookfyCartAdded', async function(event) {
  console.log('Lookfy cart added:', event.detail);

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  try {
    const config = fetchConfig();
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const body = JSON.stringify({
      updates: {},
      sections: cartDrawer.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    config.body = body;

    const response = await fetch(`${routes.cart.cart_update_url}`, config);
    const parsedState = await response.json();

    publish('cart-update', {
      source: 'lookfy',
      cartData: parsedState
    });

    cartDrawer.renderContents(parsedState);
  } catch (e) {
    console.error('Errore aggiornamento carrello Lookfy:', e);
    cartDrawer.open();
  }
});